const AppointmentList = resolve => require.ensure([], () => resolve(require('./appointment-list/AppointmentList.vue')), 'AppointmentList')
const Appoint = resolve => require.ensure([], () => resolve(require('./apoint/Appoint.vue')), 'Appoint')
const SearchList = resolve => require.ensure([], () => resolve(require('./search-list/SearchList.vue')), 'SearchList')
const AppointMain = resolve => require.ensure([], () => resolve(require('./appoint-main/AppointMain.vue')), 'AppointMain')
const EmpAppoint = resolve => require.ensure([], () => resolve(require('./emp-appoint/EmpAppoint.vue')), 'EmpAppoint')
const StoreAppoint = resolve => require.ensure([], () => resolve(require('./store-appoint/StoreAppoint.vue')), 'StoreAppoint')
const NewAppointMain = resolve => require.ensure([], () => resolve(require('./appoint-main/NewAppointMain.vue')), 'NewAppointMain')
const CancelAppoint = resolve => require.ensure([], () => resolve(require('./cancel-appoint/index.vue')), 'CancelAppoint')

export {
    AppointmentList,
    Appoint,
    SearchList,
    AppointMain,
    EmpAppoint,
    StoreAppoint,
    NewAppointMain,
    CancelAppoint
} 



// WEBPACK FOOTER //
// ./src/pages/appointment/index.js